import "core-js/modules/es.reflect.construct.js";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { isWindowUndefined } from "./server-side-rendering/isWindowUndefined";
/* eslint-disable @faire/no-local-storage */
/* eslint-disable @faire/one-exported-class-per-file */
var getLocalStorage = function getLocalStorage() {
  try {
    if (isWindowUndefined()) {
      return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @faire-web/no-restricted-globals
    return window.localStorage;
  } catch (_) {
    return undefined;
  }
};
var getSessionStorage = function getSessionStorage() {
  try {
    if (isWindowUndefined()) {
      return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @faire-web/no-restricted-globals
    return window.sessionStorage;
  } catch (_) {
    return undefined;
  }
};
export var Storage = /*#__PURE__*/function () {
  function Storage(dataStorage) {
    var _this = this;
    _classCallCheck(this, Storage);
    this.dataStorage = dataStorage;
    this._fallbackCache = {};
    this.isStorageAvailable = function () {
      if (!_this.dataStorage) {
        return false;
      }
      var testKey = "test";
      try {
        _this.dataStorage.setItem(testKey, "test");
        _this.dataStorage.removeItem(testKey);
      } catch (_) {
        return false;
      }
      return true;
    };
    this.getItem = function (key) {
      if (_this.isStorageAvailable()) {
        var value = _this.dataStorage.getItem(key);
        if (typeof value === "string") {
          return value;
        }
      }
      if (_this._fallbackCache[key] !== undefined) {
        return _this._fallbackCache[key];
      }
      return undefined;
    };
    this.setItem = function (key, value) {
      if (_this.isStorageAvailable()) {
        _this.dataStorage.setItem(key, value);
        return;
      }
      _this._fallbackCache[key] = value;
    };
    this.removeItem = function (key) {
      if (_this.isStorageAvailable()) {
        _this.dataStorage.removeItem(key);
        return;
      }
      delete _this._fallbackCache[key];
    };
    this.clear = function () {
      if (_this.isStorageAvailable()) {
        _this.dataStorage.clear();
        return;
      }
      _this._fallbackCache = {};
    };
  }
  return _createClass(Storage, null, [{
    key: "local",
    get: function get() {
      return LocalStorage.get();
    }
  }, {
    key: "session",
    get: function get() {
      return SessionStorage.get();
    }
  }]);
}();
export var LocalStorage = /*#__PURE__*/function (_Storage) {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
    return _callSuper(this, LocalStorage, [getLocalStorage()]);
  }
  _inherits(LocalStorage, _Storage);
  return _createClass(LocalStorage);
}(Storage);
LocalStorage.get = singletonGetter(LocalStorage);
export var SessionStorage = /*#__PURE__*/function (_Storage2) {
  function SessionStorage() {
    _classCallCheck(this, SessionStorage);
    return _callSuper(this, SessionStorage, [getSessionStorage()]);
  }
  _inherits(SessionStorage, _Storage2);
  return _createClass(SessionStorage);
}(Storage);
SessionStorage.get = singletonGetter(SessionStorage);
/**
 * @deprecated Use Storage.local. This const is evaluated too early in a cypress context.
 */
export var StorageService = new LocalStorage();